/**
 * @desc 获取ParticipatingEquipmentThatIsRaisingHand列表
 */

import * as SWR from 'swr';

import * as defs from '../../baseClass';
import * as Hooks from '../../../hooks';
import { PontCore } from '../../../pontCore';

export class Params {
  /** 会议房间 ID */
  channelId?: number;
}

export const method = 'GET';

export function mutate(
  params = {},
  newValue = undefined,
  shouldRevalidate = true,
) {
  return SWR.mutate(
    Hooks.getUrlKey(
      '/api/bs-vmeeting/web/v3/meeting/reaction/hand-up/devices',
      params,
      'GET',
    ),
    newValue,
    shouldRevalidate,
  );
}

export function useRequest(params = {}, swrOptions = {}) {
  return Hooks.useRequest(
    '/api/bs-vmeeting/web/v3/meeting/reaction/hand-up/devices',
    params,
    swrOptions,
  );
}

export function request(params: Params, options?: any) {
  return PontCore.fetch(
    PontCore.getUrl(
      '/api/bs-vmeeting/web/v3/meeting/reaction/hand-up/devices',
      params,
      'GET',
    ),
    {
      method: 'GET',

      ...options,
    },
  );
}
